// @flow strict
// $FlowFixMe[nonstrict-import]
import {EXTENSION_ID} from 'src/chat-extension/constants';


export const sendMessageToExtension = (type: string, payload: mixed) => {
  const chrome = window.chrome;
  if (!chrome || !chrome.runtime) {
    return;
  }
  chrome.runtime.sendMessage(EXTENSION_ID, {type, payload});
};
